import React from "react";
import {
  useLocation,
  useNavigate,
  useParams,
} from "react-router-dom";

import { useSelector } from "react-redux";

import "./css/SuccessScreen.css";


function SuccessScreen() {

  const {
    restaurantId,
    tableId,
  } = useParams();

  const navigate = useNavigate();

  const location = useLocation();


  /*
  =====================================================
  RESTAURANT NAME
  =====================================================
  */

  const {
    restaurantName,
  } = useSelector(
    (state) => state.theme
  );


  /*
  =====================================================
  SUCCESS DATA
  =====================================================
  */

  const orderId =
    location.state?.orderId ||
    location.state?.order_id ||
    null;


  const paymentMethod =
    location.state?.paymentMethod ||
    "CASH";


  const total =
    Number(
      location.state?.total || 0
    );


  /*
  =====================================================
  PAYMENT LABEL
  =====================================================
  */

  const paymentLabel =
    paymentMethod === "ONLINE"
      ? "ONLINE PAYMENT"
      : "CASH";


  /*
  =====================================================
  RETURN TO MENU
  =====================================================
  */

  const handleReturnToMenu = () => {

    navigate(
      `/${restaurantId}/table/${tableId}`
    );

  };


  /*
  =====================================================
  VIEW ORDER
  =====================================================
  */

  const handleViewOrder = () => {

    /*
    If you later create an order-status
    page, you can navigate there.

    For now, return to menu.
    */

    navigate(
      `/${restaurantId}/table/${tableId}`
    );

  };


  return (

    <div className="theme3-success-page">

      <div className="theme3-success-container">


        {/* =================================================
            DECORATIVE TOP
        ================================================= */}

        <div className="theme3-success-decoration">

          <span></span>

          <span>✦</span>

          <span></span>

        </div>


        {/* =================================================
            SUCCESS ICON
        ================================================= */}

        <div className="theme3-success-icon-wrapper">

          <div className="theme3-success-icon">

            <span>
              ✓
            </span>

          </div>

        </div>


        {/* =================================================
            MAIN MESSAGE
        ================================================= */}

        <div className="theme3-success-heading">

          <span className="theme3-success-eyebrow">
            THANK YOU
          </span>


          <h1>
            ORDER CONFIRMED
          </h1>


          <p>
            Your order has been successfully
            placed at{" "}
            <strong>
              {restaurantName ||
                "the restaurant"}
            </strong>.
          </p>

        </div>


        {/* =================================================
            ORDER CARD
        ================================================= */}

        <div className="theme3-success-card">


          {/* TOP */}

          <div className="theme3-success-card-top">

            <div>

              <span>
                ORDER
              </span>

              <strong>
                {orderId
                  ? `#${orderId}`
                  : "CONFIRMED"}
              </strong>

            </div>


            <div className="theme3-success-status">

              <span className="theme3-success-status-dot"></span>

              CONFIRMED

            </div>

          </div>


          {/* DIVIDER */}

          <div className="theme3-success-divider"></div>


          {/* DETAILS */}

          <div className="theme3-success-details">


            {/* RESTAURANT */}

            <div className="theme3-success-detail">

              <span>
                RESTAURANT
              </span>

              <strong>
                {restaurantName ||
                  "Restaurant"}
              </strong>

            </div>


            {/* TABLE */}

            <div className="theme3-success-detail">

              <span>
                TABLE
              </span>

              <strong>
                {tableId}
              </strong>

            </div>


            {/* PAYMENT */}

            <div className="theme3-success-detail">

              <span>
                PAYMENT
              </span>

              <strong>
                {paymentLabel}
              </strong>

            </div>


            {/* TOTAL */}

            <div className="theme3-success-detail">

              <span>
                TOTAL
              </span>

              <strong className="theme3-success-total">
                ₹{total.toFixed(2)}
              </strong>

            </div>

          </div>


          {/* DIVIDER */}

          <div className="theme3-success-divider"></div>


          {/* MESSAGE */}

          <div className="theme3-success-message">

            <div className="theme3-success-message-icon">
              ✦
            </div>

            <p>
              {paymentMethod === "ONLINE"
                ? "Your payment has been received and your order is being prepared."
                : "Your order has been sent to the restaurant. Please pay at the restaurant when requested."}
            </p>

          </div>

        </div>


        {/* =================================================
            ACTIONS
        ================================================= */}

        <div className="theme3-success-actions">

          <button
            type="button"
            className="theme3-success-primary-button"
            onClick={handleReturnToMenu}
          >
            RETURN TO MENU
            <span>
              →
            </span>
          </button>

        </div>


        {/* =================================================
            FOOTER MESSAGE
        ================================================= */}

        <p className="theme3-success-footer-text">

          We appreciate you dining with{" "}

          <span>
            {restaurantName ||
              "us"}
          </span>

          .

        </p>


      </div>

    </div>

  );

}


export default SuccessScreen;